module.exports = __webpack_public_path__ + "static/media/page_2h_right.9a843cc8.png";